import { render } from "./HeroSettingGeneralInfo.vue?vue&type=template&id=64d3a01b&scoped=true"
import script from "./HeroSettingGeneralInfo.vue?vue&type=script&lang=js"
export * from "./HeroSettingGeneralInfo.vue?vue&type=script&lang=js"

import "./HeroSettingGeneralInfo.vue?vue&type=style&index=0&id=64d3a01b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d3a01b"]])

export default __exports__